import { NotificationComponent, NotificationScreens } from "@shared/types";

export const NOTIFICATIONS_FETCH_INTERVAL_SECONDS = 60;

const CLICKABLE_SCREENS = [
  NotificationScreens.TRADE_DETAIL,
  NotificationScreens.TRADES,
  NotificationScreens.GROUPS,
  NotificationScreens.ACCOUNT_DETAIL,
  NotificationScreens.BOT_DETAIL,
  NotificationScreens.ACCOUNT_FORM,
];

export const WEB_CLICKABLE_SCREENS = new Set([
  ...CLICKABLE_SCREENS,
  NotificationScreens.SUBSCRIPTION,
]);

export const APP_CLICKABLE_SCREENS = new Set(CLICKABLE_SCREENS);

export const AGGREGATE_NOTIFICATION_COMPONENT_TO_BUTTON_TEXT: {
  [component in NotificationComponent]?: string;
} = {
  [NotificationComponent.ORDER]: "Trade",
  [NotificationComponent.TRADE]: "Trade",
};
